import DriverGuideIndex from "@/views/driver-guide/DriverGuideIndex.vue";

const driverGuide = [
    {
        path: '/driverguide',
        name: 'driverguide',
        component: DriverGuideIndex
    }
]

export default driverGuide;